import { StepOne } from './step-one'
import { StepTwo } from './step-two'
import { StepThree } from './step-three'
import { useForm } from './form-provider'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

function FormSteps() {
  const { step } = useForm()

  return (
    <div className="w-full max-w-screen-sm 2xl:max-w-screen-lg  mx-auto">
      <div className="relative">
      </div>

      <div className="mb-8">
        <div className="flex items-center justify-between">
          {[1, 2, 3].map((number) => (
            <div key={number} className="flex items-center">
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center ${
                  step >= number
                    ? 'bg-blue-600 text-white'
                    : 'bg-gray-200 text-gray-500'
                }`}
              >
                {number}
              </div>
              {number < 3 && (
                <div
                  className={`h-1 w-[33vw] lg:w-[270px] 2xl:w-[464px] ${
                    step > number ? 'bg-blue-600' : 'bg-gray-200'
                  }`}
                />
              )}
            </div>
          ))}
        </div>
        <div className="mt-4 grid grid-cols-3 text-left text-[10px] lg:text-sm text-gray-600 w-full">
          <div className='text-left'>Education Background</div>
          <div className='text-center'>Preference</div>
          <div className='text-right'>Test Score</div>
          {/* <div>Career Goals</div> */}
        </div>
      </div>
      <div className="p-6 bg-white rounded-lg border border-gray-200 shadow-sm">
        {step === 1 && <StepOne />}
        {step === 2 && <StepTwo />}
        {step === 3 && <StepThree />}
      </div>
    </div>
  )
}


export function EducationForm() {
const {resetFormData} = useForm();
const navigate = useNavigate();
useEffect(() => {
  resetFormData();
}, []); 
  return (
      <div className="min-h-screen p-6 bg-gray-50 relative">
        {/* Back to Home Button */}
        <div className="hidden sm:block absolute top-4 right-4">
            <button className="bg-blue-600 px-6 py-2 text-sm font-semibold text-white rounded shadow-sm hover:bg-blue-500"
              onClick={() => {
                navigate('/');
              }}>
              Back to Home
            </button>
        </div>
        
        <div className="max-w-2xl 2xl:max-w-7xl mx-auto mb-8 text-center">
          <h1 className="text-3xl font-bold tracking-tight mb-2 text-gray-900 2xl:text-6xl">
            Search programs matching your eligibility criteria
          </h1>
          <p className="text-gray-600 2xl:text-xl">
            Don't know where you fit the best? Take these 3 steps and find out what's best for you.
          </p>
        </div>
        <FormSteps />
      </div>
  
  )
}